import { apiFetch, clearSession } from './api';
import { scheduleAutoLogout, stopSessionWatcher } from './sessionWatcher.js';

/* ==============================|| LOGIN ||============================== */

export async function login(email, password) {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });

  // Tu backend responde: { access_token, user }
  if (!data?.access_token) {
    throw new Error('El servidor no devolvió un token válido.');
  }

  localStorage.setItem('token', data.access_token);
  if (data.user) {
    localStorage.setItem('user', JSON.stringify(data.user));
  }

  //  Reprogramar el auto-logout con el nuevo token
  scheduleAutoLogout();

  return data;
}

/* ==============================|| LOGOUT ||============================== */

export function logout({ redirect = true } = {}) {
  stopSessionWatcher(); //  cancelar el timer
  clearSession();
  if (redirect) {
    window.location.href = '/login';
  }
}

/* ==============================|| USER ||============================== */

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getToken() {
  return localStorage.getItem('token');
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload?.exp) return true;
    return Date.now() < payload.exp * 1000;
  } catch {
    return false;
  }
}